import { render, staticRenderFns } from "./RegisterPemilikSistem.vue?vue&type=template&id=8394174c&scoped=true&"
import script from "./RegisterPemilikSistem.vue?vue&type=script&lang=js&"
export * from "./RegisterPemilikSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8394174c",
  null
  
)

export default component.exports